import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Cookies from 'js-cookie'
import { Footer, Nav, Analytics } from './elements'

class Profile extends Component {

    constructor() {
        super()
        this.state = {
            isLogin: false,
            user: ""
        }
    }

    componentWillMount() {
        if(Cookies.get('user')){
            this.setState({
                isLogin: true,
                user: JSON.parse(Cookies.get('user'))
            })
        } else {
            window.location = "/login"
        }
    }

    render() { 
        if(!this.state.isLogin) return <div></div>
        return (
            <div className="page-profile">
                <Analytics />
                <div className="profile-header">
                    <div className="nothing">
                        <p>&nbsp;</p>
                    </div>
                    <div className="title">
                        <p>ประวัติ</p>
                    </div>
                    <Nav />
                </div>
                <div className="bg-blue"><p>&nbsp;</p></div>
                <div className="section-profile container">
                    <div className="profile-picture">
                        <img src={this.state.user.pic} alt="profilepicture"/>
                    </div>
                    <div className="profile-info">
                        <div className="inner-one">
                            <h2 className="user-name">{`${this.state.user.firstname} ${this.state.user.lastname}`}</h2>
                            <p className="user-id">ID : {this.state.user.user_id}</p>
                        </div>
                        <div className="inner-two">
                            <div className="point">
                                <h2 className="user-point">{this.state.user.point}</h2>
                                <p>คะแนน</p>
                            </div>
                            <div className="privilege">
                                <Link to="/pointdetail">
                                    <img src={require("../static/images/02_profile/gift.png")} alt="สิทธิพิเศษ"/>
                                    <h5>สิทธิพิเศษ</h5>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="other-menu container">
                    <Link to="/productbrand" className="menu-item">
                        <div className="btn-item btn-stock">
                            <img src={require("../static/images/02_profile/stock.png")} alt="เช็คสินค้า"/>
                            <h4>เช็คสินค้า</h4>
                        </div>
                    </Link>
                    <Link to="/partsbrand" className="menu-item">
                        <div className="btn-item btn-parts">
                            <img src={require("../static/images/02_profile/parts.png")} alt="ราคาอะไหล่"/>
                            <h4>ราคาอะไหล่</h4>
                        </div>
                    </Link>
                    <Link to="/promotion" className="menu-item mt" style={{width: '100%'}}>
                        <div className="btn-item btn-promotion">
                            <img src={require("../static/images/02_profile/promotion.png")} alt="โปรโมชั่น"/>
                            <h4>โปรโมชั่น</h4>
                        </div>
                    </Link>
                    {/* <Link to="/downloadbrand" className="menu-item mt">
                        <div className="btn-item btn-download">
                            <img src={require("../static/images/02_profile/download.png")} alt="ดาวน์โหลดเอกสาร"/>
                            <h4>ดาวน์โหลดเอกสาร</h4>
                        </div>
                    </Link> */}
                </div>
                <div className="vat container">
                    <a href="http://line.me/ti/p/~@546nyevn" target="_blank" rel="noopener noreferrer">ติดตามใบกำกับภาษี</a>
                </div>
                <div className="phone">
                    <div className="container">
                        <img src={require("../static/images/phonenumber.jpg")} alt="เบอร์ศูนย์"/>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
 
export default Profile;